export default {
	title: '',
	description: '',
	attachment: null,
	category_id: null,
};
